export default __webpack_public_path__ + "images/LH.eb1f929.png";